/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NappiCodeRecordModel } from '../../models/nappi-code-record-model';

export interface NappiCodeIdGet$Params {
  id: string;
}

export function nappiCodeIdGet(http: HttpClient, rootUrl: string, params: NappiCodeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<NappiCodeRecordModel>> {
  const rb = new RequestBuilder(rootUrl, nappiCodeIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<NappiCodeRecordModel>;
    })
  );
}

nappiCodeIdGet.PATH = '/NappiCode/{id}';
